export default __webpack_public_path__ + "static/media/telegram.775c18c6.svg";